module.exports = " <div> <router-view></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/Router/index.vue
// module id = 235
// module chunks = 6